import React, { Component } from 'react';
import { Button, Alert, Row } from 'react-bootstrap';
import Backend from '../Backend';
import ReactNotification from 'react-notifications-component';
import { store } from 'react-notifications-component';
import Connection from '../Calls';

const jwt = require('jsonwebtoken');
var moment = require("moment");

class RenovateTokenAlertIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      renewSesionMessage: false,
    }
  }

  componentWillMount() {
    this.pruebaToken();
  }

  componentDidMount() {
    this.interval = setInterval(() => this.pruebaToken(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  pruebaToken() {
    const self = this;
    const token = localStorage.getItem('token');
    var dateNow = new Date();
    var timeLimit = 300;
    var decodedToken = jwt.decode(token, { complete: true });
    var timeToken = decodedToken?.payload.exp;
    var timeServer = moment().startOf(dateNow).unix();
    var timeRemaining = timeToken - timeLimit;
    if (timeServer >= timeToken) {
      clearInterval(this.interval);
      store.addNotification({
        title: "Error!",
        message: "Session expired, please login again",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
      setTimeout(function () { localStorage.removeItem("token"); window.location.href = "https://home.wirebit.com"; }, 4000);
    } else if (timeServer >= timeRemaining) {
      var timeCount = timeToken - timeServer;
      timeCount %= 3600;
      let minutes = Math.floor(timeCount / 60);
      let seconds = timeCount % 60;
      minutes = String(minutes).padStart(2, "0");
      seconds = String(seconds).padStart(2, "0");
      var result = minutes + ":" + seconds
      this.setState({ renewSesionMessage: true, timeCountMessage: result });
    }
  }
 
  renovarSesion() {
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.RenovateToken(localStorage.getItem("email"), localStorage.getItem("token"), response.payload.r01, response => {
        if (response.status.code === "0") {
          store.addNotification({
            title: "Success!",
            message: response.payload.message,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
          localStorage.setItem("token", response.payload.token);
          this.setState({ renewSesionMessage: false })
        } else {
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
      });
    });
  }

  render() {
    return (
      <div>
        <Alert
          className='alerta-success-expired-session'
          onClose={() => { this.setState({ renewSesionMessage: false }) }}
          dismissible
          show={this.state.renewSesionMessage}
          variant="success">
          <Row style={{ justifyContent: 'center' }}>
            <p style={{ color: "#FFFFFF", marginBottom: 0 }}>
              Your session will expire in {this.state.timeCountMessage}.
              <Button variant="link" onClick={() => { this.renovarSesion() }} style={{ color: "#292D3D" }}>Would you like more time?</Button>
            </p>
          </Row>
        </Alert>

      </div>
    );
  }
} export default RenovateTokenAlertIndex;
